var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$modal.modalContentContainer }, [
    _c(
      "div",
      { class: _vm.$modal.modalContent },
      [
        _c("v-flex", [
          _c("p", { class: _vm.$modal.modalText }, [
            _vm._v("\n        Please select one of the options below:\n      ")
          ])
        ]),
        _vm._v(" "),
        _c(
          "v-flex",
          { class: _vm.$style.modalButtons },
          [
            _c(
              "BaseButton",
              {
                class: _vm.$style.modalBtn,
                attrs: { "button-style": "Main" },
                on: { click: _vm.handleCreateAccount }
              },
              [_vm._v("\n        Create Account\n      ")]
            ),
            _vm._v(" "),
            _vm.showGuestButton
              ? _c(
                  "BaseButton",
                  {
                    class: _vm.$style.modalBtn,
                    attrs: { "button-style": "Main" },
                    on: { click: _vm.handleGuestCheckout }
                  },
                  [_vm._v("\n        Guest Checkout\n      ")]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("v-flex", { class: _vm.$modal.fullWidth }, [
          _c("p", { class: _vm.$style.centeredTitle }, [
            _c("span", [_vm._v("Or")])
          ])
        ]),
        _vm._v(" "),
        _c("v-flex", { class: _vm.$modal.signIn }, [
          _c("p", [_vm._v("Already have an account?")]),
          _vm._v(" "),
          _c("button", { on: { click: _vm.handleSighIn } }, [_vm._v("Sign In")])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/CheckoutModal.vue?vue&type=template&id=021d7cf2&
// module id = null
// module chunks = 